<template>
  <a :class="['button d-flex justify-content-between align-items-center',{'action-disabled':disabled}]">
    <!-- :disabled="disabled"> -->
    <div>
      <slot></slot>
    </div>
    <div class="error"
         v-if="error && error != ''">
      <i class="fas fa-exclamation-triangle error-icon"
         :id="`error-detail-${error}`"
         href="#"
         tabindex="0" />

      <b-tooltip :target="`error-detail-${error}`"
                 triggers="hover"
                 placement="bottom">
        <div class="tooltipError d-flex justify-content-between">
          <i class="fas fa-exclamation-triangle" />
          <p>{{error}}</p>
        </div>
      </b-tooltip>
    </div>
  </a>
</template>

<script>
export default {
  name: 'ServerActionButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
  },
}
</script> 

<style lang="scss">
.button {
  cursor: pointer;
  display: flex;
  align-items: center;
  min-height: 30px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
  color: #fff;
  background-color: transparent;
  padding: 7px 10px 7px 20px;
  border: 1px solid #fff;
  border-radius: 6px;
  transition: opacity 0.15s ease-in-out, color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;

  &.primary {
    background-color: #456dea;
    border: 1px solid #456dea;
  }

  &.danger {
    background-color: #f64e60;
    border: 1px solid #f64e60;
  }

  &.default {
    background-color: #000;
    border: 1px solid #000;
  }

  i {
    margin-right: 8px;
    color: #fff;
  }

  &:hover {
    color: #fff;
    opacity: 0.8;
    text-decoration: none;
  }

  &.action-disabled {
    pointer-events: none;
    border: 1px solid #f0f3f5;
    background: #f0f3f5;
    color: #b5b5c3;

    i {
      color: #b5b5c3;
    }

    .error .error-icon {
      color: #f64e60;
    }
  }

  .error {
    .error-icon {
      font-weight: 900;
      font-size: 10px;
      line-height: 10px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #b5b5c3;
    }
  }
}
.tooltipError {
  i {
    font-weight: 900;
    font-size: 20px;
    line-height: 20px;
    color: #f64e60;
    margin-right: 10px;
    margin-top: 5px;
  }
  p {
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #212121;
    text-align: left;
  }
}
.tooltipInfo {
  i {
    font-weight: 900;
    font-size: 20px;
    line-height: 20px;
    color: #ffa800;
    margin-right: 10px;
    margin-top: 5px;
  }
  p {
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #212121;
    text-align: left;
  }
}

[disabled] {
  opacity: 1;
  pointer-events: none;
}
</style>